<template>
  <div class="merge-fields-group-wrapper" :class="{ 'mb-2': !marginBottomEmtpy }">
    <h6 v-if="!hideTitle" class="h6">Merge fields</h6>
    <div v-click-outside="onClickOutside" class="mergefield-dropdown">
      <div class="mergefield-dropdown-element" :class="{ 'open': open }">
        <b-button class="d-block" variant="outline-dark" :size="dropdownSize" @click="toggleOpen">Personalization <i class="uil uil-angle-down"></i></b-button>
        <ul class="main-ul" :class="position">
          <li v-if="!hideContactDropdown" class="dropdown-item"><a href="javascript:;">Contact Info <i class="uil uil-angle-right"></i></a>
            <ul>
              <li @click="appendField('[first_name]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> First Name</a>
              </li>
              <li @click="appendField('[last_name]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Last Name</a>
              </li>
              <li @click="appendField('[email]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Email Address</a>
              </li>
              <li @click="appendField('[phone_number]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Phone Number</a>
              </li>
              <li v-if="showKeyword" @click="appendField('[keyword]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Keyword</a>
              </li>
              <li @click="appendField('[birthday]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Birthday</a>
              </li>
              <li @click="appendField('[anniversary]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Anniversary</a>
              </li>
              <li @click="appendField('[business_name]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Business Name</a>
              </li>
              <li @click="appendField('[website_url]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Website URL</a>
              </li>
              <li v-if="showRedemption && useStaticCoupon" @click="appendField('[static_code]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Static Code</a>
              </li>
              <li v-if="showRedemption" @click="appendField('[dynamic_code]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Dynamic Code</a>
              </li>
              <li v-if="showRedemption && !hideExpireDate" @click="appendField('[expiration_date]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Date Offer Expires</a>
              </li>
              <li v-if="showContactLink" @click="appendField('[referral_link]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Referral Link</a>
              </li>
              <li v-if="showContactLink" @click="appendField('[points_page]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Points Page</a>
              </li>
              <li v-if="useGotoWebinarIntegration" @click="appendField('[gotowebinar_join_url]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> GotoWebinar Join URL</a>
              </li>
              <li v-if="useVoteCoupon" @click="appendField('[vote_options]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Vote Options</a>
              </li>

              <li v-for="customField in customFields" :key="customField.id" @click="appendField(`[custom_${customField.name }]`)">
                <a href="javascript:;"><i class="uil uil-copy"></i> {{ customField.name }}</a>
              </li>
            </ul>
          </li>
          <li class="dropdown-item"><a href="javascript:;">User Info <i class="uil uil-angle-right"></i></a>
            <ul>
              <li @click="appendField('[company]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Business Name</a>
              </li>
              <li @click="appendField('[business_phone]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Business Phone</a>
              </li>
              <li @click="appendField('[marketing_number]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Marketing Number</a>
              </li>
            </ul>
          </li>
          <li v-if="useSamcartIntegration" class="dropdown-item"><a href="javascript:;">Samcart <i class="uil uil-angle-right"></i></a>
            <ul>
              <li @click="appendField('[product_id]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Product ID</a>
              </li>
              <li @click="appendField('[product_name]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Product Name</a>
              </li>
              <li @click="appendField('[product_price]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Product Price</a>
              </li>
              <li @click="appendField('[quantity]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Quantity</a>
              </li>
              <li @click="appendField('[order_id]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Order ID</a>
              </li>
              <li @click="appendField('[order_total_price]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Order Total Price</a>
              </li>
            </ul>
          </li>
          <li v-if="useStripeIntegration" class="dropdown-item"><a href="javascript:;">Stripe <i class="uil uil-angle-right"></i></a>
            <ul>
              <li @click="appendField('[invoice_total]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Total Amount</a>
              </li>
              <li @click="appendField('[invoice_desc]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Description</a>
              </li>
              <li @click="appendField('[hosted_invoice_url]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Payment Page</a>
              </li>
              <li @click="appendField('[invoice_pdf]')">
                <a href="javascript:;"><i class="uil uil-copy"></i> Invoice PDF</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    textField: {
      type: Object,
      required: false,
      default: null,
    },
    showRedemption: {
      type: Boolean,
      default: false,
    },
    hideExpireDate: {
      type: Boolean,
      default: false,
    },
    showKeyword: {
      type: Boolean,
      default: false,
    },
    showContactLink: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    dropdownSize: {
      type: String,
      default: '',
    },
    hideContactDropdown: {
      type: Boolean,
      default: false,
    },
    hideSamcartDropdown: {
      type: Boolean,
      default: false,
    },
    hideStripeDropdown: {
      type: Boolean,
      default: false,
    },
    marginBottomEmtpy: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'down',
    },
  },

  data: function () {
    return {
      open: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters['auth/user']
    },

    useSamcartIntegration() {
      return !this.hideSamcartDropdown && this.user && this.user.business && this.user.business.use_integration && this.user.business.has_integrations.samcart
    },

    useStripeIntegration() {
      return !this.hideStripeDropdown && this.user && this.user.business && this.user.business.use_integration && this.user.business.has_integrations.stripe
    },

    useStaticCoupon() {
      return this.$store.getters['keyword/useStaticCoupon']
    },

    useVoteCoupon() {
      return this.$store.getters['keyword/useVoteCoupon']
    },

    useGotoWebinarIntegration() {
      return !this.hideContactDropdown && this.user && this.user.business && this.user.business.has_integrations.goto
    },

    customFields() {
      return this.$store.getters["auth/customFields"];
    },
  },

  methods: {
    onClickOutside() {
      this.open = false
    },
    toggleOpen() {
      this.open = true
    },
    appendField(field) {
      if (this.textField && this.textField.$el) {
        this.textField.$el.querySelector('textarea').focus()
        document.execCommand('insertText', false, field)
      } else {
        this.$emit('selected', field)
      }
      this.open = false
    }
  }
}
</script>
<style lang="scss" scoped>
.merge-fields-group-wrapper {
  .mergefield-dropdown,
  .mergefield-dropdown ul,
  .mergefield-dropdown li,
  .mergefield-dropdown a {
    margin: 0;
    padding: 0;
    line-height: normal;
    list-style: none;
    display: block;
    position: relative;
  }
  .mergefield-dropdown {
    display: inline-block;
  }

  .mergefield-dropdown ul {
    opacity: 0;
    position: absolute;
    top: 100%;
    left: -9999px;
    z-index: 999;
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
    &.main-ul.up {
      top: auto;
      bottom: 100%;
    }
  }

  .mergefield-dropdown-element.open>ul {
    left: 0;
    opacity: 1;
    z-index: 1000;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .15);
    background: #fff;
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both;
  }

  .mergefield-dropdown li:hover>ul {
    left: 0;
    opacity: 1;
    z-index: 1000;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, .15);
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both;
  }

  .mergefield-dropdown ul li:hover>ul {
    top: 0;
    left: 100%;
  }

  .mergefield-dropdown ul.up li:hover>ul {
    top: auto;
    bottom: 0;
  }

  .mergefield-dropdown li {
    cursor: default;
    float: left;
    white-space: nowrap;
  }

  .mergefield-dropdown ul li {
    float: none;
  }

  /* sub width */
  .mergefield-dropdown ul {
    min-width: 12em;
    -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.25);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.25);
  }

  /* root */
  .mergefield-dropdown a {
    padding: 0 10px;
    color: #333;
    font-weight: normal;
    font-size: 16px;
    line-height: 40px;
    text-decoration: none;
  }

  /* root: hover/persistence */
  .mergefield-dropdown a:hover,
  .mergefield-dropdown a:focus,
  .mergefield-dropdown li:hover a {
    background: #fff;
    color: #333;
  }

  /* 2 */
  .dropdown-item a,
  .mergefield-dropdown li li a,
  .mergefield-dropdown li:hover li a {
    padding: 10px 10px;
    background: #fff;
    color: #333;
    font-size: 14px;
    line-height: normal;
    display: flex;
    justify-content: flex-start;
  }

  .dropdown-item a {
    justify-content: space-between; 
  }

  /* 2: hover/persistence */
  .mergefield-dropdown li:hover li a:hover,
  .mergefield-dropdown li:hover li a:focus,
  .mergefield-dropdown li:hover li:hover a {
    background: #efefef;
  }
}
</style>